import axios from 'axios'
import { AUTH_TOKEN } from '../vue-apollo'
import { getHost } from '../config'

const BASE_URL = `https://staff-v2-api.${getHost()}/`

export const staffApi = axios.create({
  baseURL: BASE_URL
})

staffApi.interceptors.request.use(
  config => {
    config.headers.Authorization = `Bearer ${window.localStorage.getItem(
      AUTH_TOKEN
    )}`
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
